module.exports = {"150783001":"兴华街道","150783002":"正阳街道","150783003":"繁荣街道","150783004":"向阳街道","150783005":"高台子街道","150783006":"铁东街道","150783007":"河西街道","150783100":"蘑菇气镇","150783102":"卧牛河镇","150783103":"成吉思汗镇","150783104":"大河湾镇","150783105":"浩饶山镇","150783106":"柴河镇","150783107":"中和镇","150783108":"哈多河镇","150783200":"达斡尔民族乡","150783201":"鄂伦春民族乡","150783202":"萨马街鄂温克民族乡","150783203":"洼堤乡","150783400":"大河湾农场","150783401":"绰尔河农场","150783402":"扎兰屯马场","150783403":"成吉思汗牧场","150783404":"公安部后勤供应处农场","150783405":"南木林业局","150783406":"柴河林业局","150783407":"扎兰屯市林业局","150783408":"市原种场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150783.json
// module id = 456
// module chunks = 0